import 'telstra-ui/resources/telstraui.css';
import 'telstra-ui/resources/themes/pacific.css';
import { ApplicationName } from '@telstra-connect/order-tracker/activity-tracking';
import { getFlags, isFlagOn, loadFeatureFlags } from '@telstra-connect/order-tracker/feature-flags';
import { secureRouteBuilder } from '../secure-route';
import OrdersSummary from './pages/orders-summary/index-lazy';
import OrderDetails from './pages/order-details/index-lazy';
import OrderDetailsNew from './bvt-page-wrappers/order-details';
import Routes from './route-constants';
import { IApplicationDefinition, IAppRegistry, IRenderRouteOptions } from '@apps-config/app-definition';
import { Activity } from '@utils/activity-tracking';
import UnifiedTrackView from './bvt-page-wrappers/unified-track-view';
import { RoutesHelper } from '@apps-config/routing/routing';
import { useNavigate } from 'react-router-dom';
import { IUserProfile } from '@telstra-connect/login/state';
import OrderDetailsUpliftment from './pages/order-details-uplifted/index-lazy';

const routes = new RoutesHelper({
  rootPath: secureRouteBuilder(Routes.OrderTracker),
  subpagesPathMask: secureRouteBuilder(Routes.OrderTracker),
});

const applicationName = ApplicationName;
const menuItemName = 'Your orders';
const tracker = Activity.createTracker(applicationName);
const RedirectToHomeComponent = () => {
  const navigate = useNavigate();
  navigate('/');
}
export const Application: IApplicationDefinition = {
  loggedInCidn: '',
  getLoggedInCidn() {
    return this.loggedInCidn;
  },

  get applicationName() {
    return applicationName;
  },

  get acceptsUserFeedback() {
    return true;
  },

  get acceptsErrorReports() {
    return true;
  },

  get card() {
    return null;
  },

  get unifiedTrackView() {
    return UnifiedTrackView;
  },

  get tracker() {
    return tracker;
  },

  get routes() {
    return routes;
  },

  init(registry: IAppRegistry, availableToUser: boolean, userProfile: IUserProfile) {
    loadFeatureFlags();
    const flags = getFlags();
    this.loggedInCidn = userProfile.companyId;
    if (availableToUser && isFlagOn(flags.application)) {
      registry.add(Application);
    }
  },
  render() {
    const flags = getFlags();
    const isOrderTrackerUpliftment = isFlagOn(flags.orderTrackerDetailsIntUIUpliftment);
    return [
      {
        path: routes.getPageSubpath(Routes.OrderDetailsRoute),
        component: isOrderTrackerUpliftment ? OrderDetailsUpliftment : OrderDetails
      },
      {
        path: routes.getPageSubpath(Routes.OrderDetailsRouteNew),
        component: OrderDetailsNew,
      },
      {
        path: routes.getPageSubpath(Routes.OrderDetailsProductSheetFullUrl),
        component: OrderDetailsNew,
      },
      {
        path: routes.getPageSubpath(Routes.OrderDetailsProgressRoute),
        component: OrderDetails,
      },
      {
        path: routes.getAppPath(),
        component: OrdersSummary,
      },
      {
        path: routes.getPageSubpath(Routes.OrdersRoute),
        component: OrdersSummary,
      },
      {
        path: routes.getPageSubpath(Routes.BrokenRoutePrefix),
        component: RedirectToHomeComponent,
      },
    ] as IRenderRouteOptions[];
  },

  menuItem(state, navigate) {
    return [
      {
        testID: 'ui-menu-orders',
        name: 'Track',
        intialPagePath: routes.getInitialPagePath(),
        appPath: routes.getAppPath(),
        onClick: null,
        subMenus: [
          {
            name: menuItemName,
            active: false,
            icon: '',
            onClick: () => {
              navigate(`${routes.getPageSubpath(Routes.OrdersRoute)}?source=menu`);
              Application.tracker.trackMenu(menuItemName);
            },
          },
        ],
      },
    ];
  },
};
